
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertCategoryC as ObiAlertCategoryCElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-category-c.js';
 
 
 

 
 export const ObiAlertCategoryC = createComponent({
   react: React,
   tagName: 'obi-alert-category-c',
   elementClass: ObiAlertCategoryCElement,
   events: {
     
   }
  });
 
 